import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { FaPlusCircle } from 'react-icons/fa';
import { FaRankingStar } from 'react-icons/fa6';
import * as Motion from 'motion/react';
import DashboardList, { DashboardLeaderboardListRenderComponent } from '../../components/DashboardList';
import Loader from '../../components/Loaders';
import useDialogBox from '../../hooks/useDialogBox';
import { createLeaderboard, getLeaderboards } from '../../api/v1/leaderboards';
import { animationStaggeredItem } from '../../animations';
import '../../styles/screen.scss';

const { motion } = Motion;


const Leaderboards = () => {
  const formRef = useRef(null);
  const [leaderboards, setLeaderboards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { resetDialogBox, setDialogBox } = useDialogBox();

  const loadLeaderboardList = async () => {
    const result = await getLeaderboards();

    setLeaderboards(result?.data);
  };

  const createLeaderboardSubmit = async () => {
    const { leaderboardSlug, leaderboardName } = formRef.current?.getValues();

    if (!leaderboardSlug.length) {
      alert('Please enter leaderboard slug');
    }
    else if (!leaderboardName.length) {
      alert('Please enter leaderboard name');
    }
    else {
      await createLeaderboard({
        leaderboardSlug: leaderboardSlug,
        displayName: leaderboardName
      });

      resetDialogBox();

      await loadLeaderboardList();
    }
  };

  const newLeaderboard = async () => {
    setDialogBox({
      title: 'Add Leaderboard',
      content: <AddLeaderboardForm ref={formRef}/>,
      actions: [
        { title: 'Create Leaderboard', type: 'primary', action: () => createLeaderboardSubmit() },
        { title: 'Cancel', type: 'cancel', action: () => resetDialogBox() }
      ]
    });
  };

  useEffect(() => {
    (async () => {
      await loadLeaderboardList();
      setIsLoading(false);
    })();
  }, []);

  return (
    <>
      <Motion.AnimatePresence>
        {isLoading && <Loader/>}
      </Motion.AnimatePresence>

      <motion.div variants={animationStaggeredItem} className="screen-header">
        <div className="screen-title-wrapper">
          <h2 className="screen-title">
            <FaRankingStar/>
            Leaderboards
          </h2>
        </div>

        <button className="screen-header-button primary" onClick={() => newLeaderboard()}>
          <FaPlusCircle/>Add Leaderboard
        </button>
      </motion.div>

      <DashboardList items={leaderboards} RenderComponent={DashboardLeaderboardListRenderComponent}/>

    </>
  )
};


const AddLeaderboardForm = forwardRef((props, ref) => {
  const [leaderboardSlug, setLeaderboardSlug] = useState('');
  const [leaderboardName, setLeaderboardName] = useState('');

  const getValues = () => {
    return { leaderboardSlug, leaderboardName };
  };

  useImperativeHandle(ref, () => ({
    getValues,
  }));

  return (
    <div className="modal-form">
      <div className="form-group">
        <label>Leaderboard Slug</label>
        <input placeholder="Leaderboard Slug" value={leaderboardSlug}
               onChange={(e) => setLeaderboardSlug(e.target.value)}/>
      </div>

      <div className="form-group">
        <label>Leaderboard Name</label>
        <input placeholder="Leaderboard Name" value={leaderboardName}
               onChange={(e) => setLeaderboardName(e.target.value)}/>
      </div>
    </div>
  );
});

export default Leaderboards;
